import { render, staticRenderFns } from "./CanvasSizer.vue?vue&type=template&id=0afb73c2&"
import script from "./CanvasSizer.vue?vue&type=script&lang=js&"
export * from "./CanvasSizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports